import type * as React from "react";
import styled from "styled-components";

import { useVersions } from "@/queries/useVersions";

interface IProps {
    value: string;
    currentVersion: string;
    onChange: (value: string) => void;
}

const Select = styled.select`
    width: 100%;
`;

function ChangeFilter({ value, currentVersion, onChange }: IProps) {
    const { data: versions = [] } = useVersions();
    const filteredVersions = versions.filter((v) => v !== currentVersion);

    const onChangeSelect = (event: React.FormEvent<HTMLSelectElement>) => {
        onChange(event.currentTarget.value);
    };

    return (
        // biome-ignore lint/a11y/noLabelWithoutControl: Select is an input
        <label>
            Show only translations that have changed since version:
            <Select value={value} onChange={onChangeSelect}>
                <option value="">---</option>
                {filteredVersions.map((v) => (
                    <option key={v} value={v}>
                        {v}
                    </option>
                ))}
            </Select>
        </label>
    );
}

export default ChangeFilter;
